<h3 mat-dialog-title>Connexion</h3>

<div mat-dialog-content>
  <form class="dialog-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <mat-form-field>
      <input formControlName="username" type="text" matInput placeholder="Nom d'utilisateur" required>
      @if (submitted && loginForm.get('username').invalid) {
        <mat-error>Champ requis</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <input formControlName="password" type="password" matInput placeholder="Mot de passe" required>
      @if (submitted && loginForm.get('password').invalid) {
        <mat-error>Champ requis</mat-error>
      }
    </mat-form-field>

    <button type="submit" mat-flat-button color="primary" [disabled]="loading">Se connecter</button>
  </form>
</div>
